import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useAppDispatch } from '@/shared/lib';
import { setLayoutType, LAYOUT_TYPES } from '@/entities/language';

import { Header } from './header';
import { Footer } from './footer';

export function PublicLayout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setLayoutType(LAYOUT_TYPES.PUBLIC));
  }, [dispatch]);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-background">
      <Header />
      <main className="flex-1 flex items-center justify-center p-6 overflow-y-auto">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
